import { Dispatch } from "react";
import { react } from "uikit";

interface Context {
	value: string;
	setError: Dispatch<boolean>;
}

export const isValidRefundPolicyUrl = (value?: string | null): boolean => {
	const url = value?.trim();
	if (!url) return true;

	try {
		const { protocol } = new URL(url);
		return protocol === "http:" || protocol === "https:";
	} catch {
		return false;
	}
};

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid = isValidRefundPolicyUrl(this.context?.value);

		if (!isValid) this.context?.setError(true);

		return isValid;
	}
}
